import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

const DetailsEmpty = ({
  icon = 'hicon-eye-open',
  text = 'No data detected for the current filter selections.',
  bodyMinHeight = 176,
} = {}) => (
  <div className="details-empty" style={{ minHeight: bodyMinHeight }}>
    <i className={cx('details-empty__icon', icon)} />
    <div className="details-empty__text">{text}</div>
  </div>
);

DetailsEmpty.propTypes = {
  icon: T.string,
  text: T.string,
  bodyMinHeight: T.number,
};

export default DetailsEmpty;
